import React from 'react';

import { PLATFORM_STATIC_ICONS_PNG } from '@/config/icons';

import styles from './LomavisPlacementOption1.module.css';

export type LomavisPlacementPlatform1 = 'facebook' | 'instagram';

export interface LomavisPlacementOption1Props {
  id: string;
  label: string;
  platform: LomavisPlacementPlatform1;
  selected: boolean;
  onToggle: (id: string) => void;
  disabled?: boolean;
}

export const LomavisPlacementOption1: React.FC<
  LomavisPlacementOption1Props
> = ({
  id,
  label,
  platform,
  selected,
  onToggle,
  disabled = false
}) => (
  <div
    className={`d-flex align-items-center justify-content-between gap-2 border rounded-3 bg-white ${
      selected ? styles.selected : ''
    }`}
  >
    <label
      htmlFor={`lomavis-placement-option-${id}`}
      className={`${styles.optionLabel} d-flex flex-grow-1 align-items-center gap-2 border-0 bg-transparent p-3 text-start text-body ${
        disabled ? 'opacity-50' : ''
      }`}
      style={{ minWidth: 0 }}
    >
      <input
        id={`lomavis-placement-option-${id}`}
        type="checkbox"
        className={styles.checkbox}
        checked={selected}
        disabled={disabled}
        onChange={() => onToggle(id)}
        aria-label={label}
      />
      <span
        className={`${styles.marker} d-inline-flex align-items-center justify-content-center`}
        aria-hidden="true"
      >
        <img
          src={PLATFORM_STATIC_ICONS_PNG[platform]}
          alt=""
          className={styles.platformLogo}
        />
      </span>
      <span className="text-truncate fw-bold">{label}</span>
    </label>
  </div>
);
